<template>
	<div ref="section_third" class="section third" v-parallax-fit="outro">
		<div class="group-image animated">
			<a class="btn-link" href="/steal-estate/resources/">
				<img src="/themes/rise-theme/dist/images/estate/TakeAction@2x.png" alt="">
				<img src="/themes/rise-theme/dist/images/estate/TakeAction@2xRO.png" alt="">
			</a>

			<img src="/themes/rise-theme/dist/images/estate/character-view/vanessa/intro/CasesBoard_Background@2x.png"
				alt="" class="bg">

			<div class="vanessa profile animated">
				<router-link @click.prevent="toTop" to="/character/vanessa">
					<img class="character-icon"
						data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png"
						src="/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa@2x.png" alt="">
				</router-link>
				<div class="shadow-img invisible"
					style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Vanessa_Glow@2x.png)">
				</div>
			</div>
			<div class="holy profile animated">
				<router-link @click.prevent="toTop" to="/character/holly">
					<img class="character-icon"
						data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png"
						src="/themes/rise-theme/dist/images/estate/character-view/characters/Holly@2x.png" alt="">
				</router-link>
				<div class="shadow-img invisible"
					style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Holly_Glow@2x.png)">
				</div>
			</div>
			<div class="henry profile animated">
				<router-link @click.prevent="toTop" to="/character/henry">
					<img class="character-icon"
						data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png"
						src="/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry@2x.png" alt="">
				</router-link>
				<div class="shadow-img invisible"
					style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/MrHenry_Glow@2x.png)">
				</div>
			</div>
			<div class="ozzie profile animated">
				<router-link @click.prevent="toTop" to="/character/ozzie">
					<img class="character-icon"
						data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png"
						src="/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie@2x.png" alt="">
				</router-link>
				<div class="shadow-img invisible"
					style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Ozzie_Glow@2x.png)">
				</div>
			</div>
			<div class="villain animated">
				<router-link @click.prevent="toTop" to="/character/villian">
					<img class="character-icon"
						data-glow-src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png"
						src="/themes/rise-theme/dist/images/estate/character-view/characters/Villain@2x.png" alt="">
				</router-link>
				<div class="shadow-img invisible"
					style="background-image: url(/themes/rise-theme/dist/images/estate/character-view/characters/Villain_Glow_1@2x.png)">
				</div>

			</div>

			<div class="outro_hand1"></div>
			<div class="outro_hand2"></div>

		</div>
	</div>
</template>

<script>
export default {
	name: 'slide31',
	props: {
		outro: {
			type: Array,
			required: false
		}
	},
	data() {
		return {
			mutationObserver: null,
		};
	},
	mounted() {
		const ch_images = document.getElementsByClassName("character-icon");
		let orig_src = '';
		for (let i = 0; i < ch_images.length; i++) {
			ch_images[i].addEventListener('mouseover', e => {
				orig_src = e.target.getAttribute('src');
				e.target.setAttribute('src', e.target.dataset.glowSrc)
			}, false);
			ch_images[i].addEventListener('mouseleave', e => {
				e.target.setAttribute('src', orig_src)
			}, false);
		}
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.opacity == this.outro[0].toStyle.opacity) {
					this.$audioUrl.value = '';
					this.$subtitlesUrl.value = '';
					this.$evidence.value = null;
					this.$readMore.value = '';
					document.querySelector('.ch-photo').style.display = 'none';
				} else {
					document.querySelector('.ch-photo').style.display = 'block';
				}
			});
		});

		this.mutationObserver.observe(this.$refs.section_third, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
	methods: {
		toTop() {
			this.$navigate.value = true;
			setTimeout(() => {
				this.$navigate.value = false;
			}, 1000);
			window.scrollTo({
				top: 0
			});
		}
	},
}
</script>


<style lang="scss" scoped>
.section {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100vh;
	width: 100%;
	position: fixed;
	left: 0;
	bottom: -100%;
	right: 0;
	transition: 0.5s;
}

.btn-link {
	position: absolute;
	top: calc(50% - 260px);
	right: 55px;
	max-width: 450px;

	img:last-child {display: none;}
	&:hover img:last-child {display: block;}
	&:hover img:first-child {display: none;}

	@media(max-width: 1500px) {
		top: calc(50% - 215px);
		right: 40px;
		max-width: 400px;
	}

	@media(max-width: 1200px) {
		top: calc(50% - 160px);
	    right: 35px;
	    max-width: 350px;
	}

	@media(max-width: 991px) {
		top: calc(50% - 120px);
	    right: 30px;
	    max-width: 300px;
	}

	@media(max-width: 600px) {
		top: 44px;
		right: initial;
		left: -95px;
		max-width: 285px;
		transform-origin: right center;
		transform: rotate(-90deg);
	}
}

.section.third {
	z-index: 15;

	@media(max-width: 600px) {
		transform-origin: center;
		transform: rotate(90deg) translateX(-70%) translateY(-1%);
	}

	.group-image {
		transition: opacity 0.3s 1s linear;
		position: relative;
		top: -5vh;
		margin-right: 0;
		max-width: 1500px;

		&>img {
			max-width: 100%;
		}

		.outro_hand1 {
			width: 290px;
			height: 900px;
			position: absolute;
			background-image: url('/themes/rise-theme/dist/images/estate/Intro_Hand_01.png');
			background-size: contain;
			background-repeat: no-repeat;
			top: 590px;
			left: calc(50% - 555px);

			@media (max-width: 1500px) {
				top: 460px;
				left: calc(50% - 475px);
			}

			@media (max-width: 1200px) {
				top: 300px;
				left: calc(50% - 400px);
			}

			@media (max-width: 991px) {
				top: 210px;
				left: calc(50% - 350px);
			}

			@media(max-width:600px) {
				transform: rotate(-90deg) translateX(380px) translateY(1320px);
			}
		}

		.outro_hand2 {
			width: 400px;
			height: 900px;
			position: absolute;
			background-image: url('/themes/rise-theme/dist/images/estate/Intro_Hand_02.png');
			background-size: contain;
			background-repeat: no-repeat;
			top: 675px;
			left: calc(50% + 560px);

			@media (max-width: 1500px) {
				top: 525px;
				left: calc(50% + 420px);
			}

			@media (max-width: 1200px) {
				top: 375px;
				left: calc(50% + 275px);
			}

			@media (max-width: 991px) {
				top: 275px;
				left: calc(50% + 185px);
			}

			@media(max-width:600px) {
				transform: rotate(-90deg) translateX(1010px) translateY(403px);
			}
		}


		.profile {
			position: absolute;
			left: 50%;
			top: 50%;
			z-index: 1;
			width: 200px;
			transform: translate(-50%, -50%) scale(1);
			transition: transform 0.3s 0.5s;

			&.disabled {
				pointer-events: none;

				img {
					filter: brightness(0.35);
				}
			}

			img {
				width: 100%;

				&:hover {
					animation: swing ease-in-out 3s alternate;
					transform-origin: 97px 19px;
					animation-iteration-count: infinite;
					transition: transform 0.5s ease-in-out;
				}
			}

			&.vanessa {
				margin-left: -7.8%;
				margin-top: -5%;
				@media(max-width:600px) {
					margin-top: 12%;
				}
				img {
					&:hover {
						transform-origin: 80px 35px;
					}
				}
			}

			&.holy {
				margin-left: 6%;
				margin-top: -3.8%;
				@media(max-width:600px) {
					margin-left: 9%;
					margin-top: 13.2%;
				}
				img {
					&:hover {
						transform-origin: 98px 25px;
					}
				}
			}

			&.henry {
				margin-top: 11.7%;
				margin-left: -8.5%;
				@media(max-width:600px) {
					margin-top: -8.3%;
				}
				img {
					&:hover {
						transform-origin: 90px 31px;
					}
				}
			}

			&.ozzie {
				margin-left: 7.5%;
				margin-top: 12%;
				@media(max-width:600px) {
					margin-top: -4%;
				}

				img {
					&:hover {
						transform-origin: 96px 30px;
					}
				}
			}

			@media (max-width: 1200px) {
				width: 140px;
			}

			@media (max-width: 991px) {
				width: 115px;
			}

			@media(max-width: 600px) {
				left: 46%;
				top: 32%;
				transform-origin: center;
				transform: rotate(-90deg);
			}
		}

		.villain {
			position: absolute;
			left: calc(72% - 30px);
			top: calc(50% - 100px);
			z-index: 2;
			width: 300px;
			transition: opacity 0.3s 1s;

			img {
				height: 260px;
				width: auto;

				&:hover {
					animation: swing ease-in-out 3s alternate;
					transform-origin: 151px 28px;
					animation-iteration-count: infinite;
					transition: transform 0.5s ease-in-out;
				}

			}

			@media (max-width: 1500px) {
				left: calc(72% - 30px);
				top: calc(50% - 100px);
				width: 250px;

				img {
					height: 240px;
				}
			}

			@media (max-width: 1200px) {
				left: calc(72% - 30px);
				top: calc(54% - 100px);
				width: 200px;

				img {
					height: 200px;
				}
			}

			@media (max-width: 991px) {
				left: calc(76% - 50px);
				top: calc(49% - 60px);
				width: 150px;

				img {
					height: 160px;
				}
			}

			@media(max-width: 600px) {
				left: calc(78% - 45px);
				top: calc(50% - 60px);
				width: 150px;
				transform: rotate(-90deg);

				img {
					height: 150px;
				}
			}
		}

		@media (max-width: 1500px) {
			max-width: 1200px;
		}

		@media (max-width: 1200px) {
			max-width: 900px;
		}

		@media (max-width: 991px) {
			max-width: 700px;
		}

		@media(max-width: 600px) {
			top: -1.8vh;
			transform: rotate(0);
			min-width: 700px;
		}
	}

	@media screen and (max-width: 320px) and (max-height: 767px) {
		zoom: 0.8;
	}
}
</style>
